import defaultConfig from "@/configs/default.config"
import { GuidClass } from "./guid"
import dayjs from 'dayjs'
import { LngLatType } from "@/models/types"

/**
 * 设置浏览器标题
 * @param title 
 */
export function setDocumentTitle(title: string){
  document.title = title
  const ua = navigator.userAgent
  // eslint-disable-next-line
  const regex = /\bMicroMessenger\/([\d\.]+)/
  if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    const i = document.createElement('iframe')
    i.src = '/favicon.ico'
    i.style.display = 'none'
    i.onload = function () {
      setTimeout(function () {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  }
}

/**
 * 数据转成tree结构
 * @param data 
 * @param parentId 
 * @returns 
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function dataToPromiseTree (data: any[], parentId: number) {
  const len = data.length
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const tree: any[] = []
  for (let i = 0; i < len; i++) {
    if (data[i].parentId === parentId) {
      const obj = {
        ...data[i]
      }
      obj.actionList = dataToPromiseTree(data, data[i].id)
      tree.push(obj)
    }
  }
  return tree
}

/**
 * 判断是否有对应的权限
 * @param permission 
 * @param route 
 * @returns 
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function hasPermission (permission: any, route: any) {
  // console.log(defaultConfig.check_auth)
  if (defaultConfig.check_auth === 'false') {
    return true
  }

  if (route.meta && route.meta.permission) {
    let flag = false
    for (let i = 0, len = permission.length; i < len; i++) {
      flag = route.meta.permission.includes(permission[i].sign)
      if (flag) {
        return true
      }
    }
    return false
  }
  return true
}

/**
 * 过滤权限菜单
 * @param routerMap 
 * @param roles 
 * @returns 
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function filterAsyncRouter (routerMap:any, roles:any) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const accessedRouters = routerMap.filter((route: any) => {
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

/**
 * 绑定事件
 * @param obj 事件对象
 * @param sType 事件名称
 * @param fn 回调函数
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function addEvent (obj: any, sType: string, fn: any) {
  if (obj.addEventListener) {
    obj.addEventListener(sType, fn, false)
  } else {
    obj.attachEvent('on' + sType, fn)
  }
}

/**
 * 移除事件
 * @param obj 事件对象
 * @param sType 事件名称
 * @param fn 回调函数
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function removeEvent (obj: any, sType: string, fn: any) {
  if (obj.removeEventListener) {
    obj.removeEventListener(sType, fn, false)
  } else {
    obj.detachEvent('on' + sType, fn)
  }
}

/**
 * 当前事件
 * @param ev 事件
 * @returns 
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function prEvent (ev: any) {
  const oEvent = ev || window.event
  if (oEvent.preventDefault) {
    oEvent.preventDefault()
  }
  return oEvent
}

/**
 * 添加滚轮事件
 * @param obj 绑定事件对象
 * @param callback 回调函数
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function addWheelEvent (obj:any, fn:any) {
  if (window.navigator.userAgent.toLowerCase().indexOf('firefox') !== -1) {
    addEvent(obj, 'DOMMouseScroll', wheel)
  } else {
    addEvent(obj, 'mousewheel', wheel)
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function wheel (ev: any) {
    const oEvent = prEvent(ev)
    const delta = oEvent.wheelDelta < 0
    fn && fn.call(oEvent, delta)
    return false
  }
}

/**
 * 随机密码
 * @param length 长度
 * @returns 
 */
export function generateRandomPassword(length: number) {
  const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let password = "";
  for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
  }
  return password;
}

/**
 * 生成guid
 * @returns 
 */
export function getNewGuid () {
  return new GuidClass().newGUID()
}
/**
 * 获取当天开始和结束的时间点
 * @returns Array
 */
export function dateBeginEndTime(){
  return [dayjs(dayjs().format('YYYY-MM-DD 00:00:00')), dayjs(dayjs().format('YYYY-MM-DD 23:59:59'))]
}

/**
 * 根据字符串计算长度，用于表格宽度计算
 * @param text 
 * @returns 
 */
export function estimateWidth(text: string) {
  console.log(text)
  let width = 0;
  for (const char of text) {
      if (/[a-zA-Z0-9]/.test(char)) {
          width += 17;
      } else {
          width += 22;
      }
  }
  if(width < 70) width += 20
  return width;
}

/**
 * 字符串转16进制hex
 * @param str 
 * @returns 
 */
export function stringToHex(str: string) {
  const hexs: string[] = []
  for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i).toString(16).padStart(2, '0')
      hexs.push('0x' + code)
  }
  return `{${hexs.join(',')}}`
}

export function guidToHex(guid: string){
  const guidArr = guid.split('-').join('').match(/.{1,2}/g)
  if(guidArr && guidArr.length > 0){
    const hexArray = guidArr.map(byte => `0x${parseInt(byte, 16).toString(16).padStart(2, '0').toUpperCase()}`)
    return `{${hexArray.join(',')}}`
  }
}

export function calculateAngle(x1: number, y1: number, x2: number, y2: number) {
  // console.log(x1,y1,x2,y2)
  // 计算斜率 m
  const slope = x2 - x1 === 0 ? 0 : (y2 - y1) / (x2 - x1)
    
  // 计算与x轴的夹角（弧度）
  const angleInRadians = Math.atan(slope)

  // 转换为度数
  const angleWithXAxisInDegrees = angleInRadians * 180 / Math.PI

  // 计算与y轴的夹角
  const angleWithYAxisInDegrees = 90 - Math.abs(angleWithXAxisInDegrees)

  // 计算方向
  const deltaX = x2 - x1
  const deltaY = y2 - y1

  if (deltaX > 0 && deltaY > 0) {
      return angleWithYAxisInDegrees
  } else if (deltaX < 0 && deltaY > 0) {
      return 180 - angleWithYAxisInDegrees
  } else if (deltaX < 0 && deltaY < 0) {
      return 180 + angleWithYAxisInDegrees
  } else if (deltaX > 0 && deltaY < 0) {
      return 360 - angleWithYAxisInDegrees
  } else if (deltaX === 0 && deltaY > 0) {
      return 0 //'y轴正方向' // 纯上方向
  } else if (deltaX === 0 && deltaY < 0) {
      return 180 //'y轴负方向' // 纯下方向
  } else if (deltaX > 0 && deltaY === 0) {
      return 90 //'x轴正方向' // 纯右方向
  } else if (deltaX < 0 && deltaY === 0) {
      return 270 //'x轴负方向' // 纯左方向
  } else {
      return 0 //'两个点重合' // 如果两个点重合
  }
}

export function isIos () {
  const isIphone = navigator.userAgent.includes('iPhone')
  const isIpad = navigator.userAgent.includes('iPad')
  if (isIphone || isIpad) {
    return true
  }
  return false
}

// WGS84 转 GCJ-02
export function wgs84ToGcj02(lng, lat): LngLatType {
  const pi = Math.PI
  const a = 6378245.0
  // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
  const ee = 0.00669342162296594323

  if (outOfChina(lng, lat)) {
      return { lng, lat }
  }

  let dLat = transformLat(lng - 105.0, lat - 35.0)
  let dLon = transformLon(lng - 105.0, lat - 35.0)
  const radLat = lat / 180.0 * pi
  let magic = Math.sin(radLat)
  magic = 1 - ee * magic * magic
  const sqrtMagic = Math.sqrt(magic)

  dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * pi)
  dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * pi)

  const mgLat = lat + dLat
  const mgLon = lng + dLon
  return { lng: mgLon, lat: mgLat }
}

// GCJ-02 转 BD09
export function gcj02ToBd09(lng, lat): LngLatType {
  const x = lng
  const y = lat
  const z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * Math.PI / 180.0)
  const theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * Math.PI / 180.0)
  const bdLon = z * Math.cos(theta) + 0.0065
  const bdLat = z * Math.sin(theta) + 0.006
  return { lng: bdLon, lat: bdLat }
}

// WGS84 转 BD09
export function wgs84ToBd09(lng, lat): LngLatType {
  const gcj02 = wgs84ToGcj02(lng, lat)
  return gcj02ToBd09(gcj02.lng, gcj02.lat)
}

// 判断是否在中国境内
function outOfChina(lng, lat) {
  return lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271
}

// 转换偏移量
function transformLat(lng, lat) {
  const pi = Math.PI
  let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng))
  ret += (20.0 * Math.sin(6.0 * lng * pi) + 20.0 * Math.sin(2.0 * lng * pi)) * 2.0 / 3.0
  ret += (20.0 * Math.sin(lat * pi) + 40.0 * Math.sin(lat / 3.0 * pi)) * 2.0 / 3.0
  ret += (160.0 * Math.sin(lat / 12.0 * pi) + 320.0 * Math.sin(lat * pi / 30.0)) * 2.0 / 3.0
  return ret
}

function transformLon(lng, lat) {
  const pi = Math.PI
  let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng))
  ret += (20.0 * Math.sin(6.0 * lng * pi) + 20.0 * Math.sin(2.0 * lng * pi)) * 2.0 / 3.0
  ret += (20.0 * Math.sin(lng * pi) + 40.0 * Math.sin(lng / 3.0 * pi)) * 2.0 / 3.0
  ret += (150.0 * Math.sin(lng / 12.0 * pi) + 300.0 * Math.sin(lng / 30.0 * pi)) * 2.0 / 3.0
  return ret
}

export function code2AreaCodes(code: number){
  const province = Math.floor(code / 10000) * 10000
  const city = Math.floor(code / 100) * 100
  return [province + '', city + '', code + '']
}

export function clone(obj){
  return JSON.parse(JSON.stringify(obj))
}

export function getAreaOptions(datas){
  const options = datas.map(x => {
    if (/(11|31|12|50)/.test(x.province)) {
      const code1 = x.code
      const code2 = (Number(x.code) + 100) + ''

      x.code = code2
      return {
        code: code1,
        name: x.name,
        province: x.province,
        children: [x]
      }
    }

    return x
  })

  return options
}